import { Component, OnInit,ViewChild, ElementRef, Injector } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { AdminService } from 'src/app/service/admin/AdminService';
import { Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { ProgressService } from 'src/app/service/ProgressService';


@Component({
  selector: 'app-manage-user-email-access',
  templateUrl: './manage-user-email-access.component.html',
  styles: [
  ]
})
export class ManageUserEmailAccessComponent extends BaseComponent implements OnInit {
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  restSub: Subscription;
  appErrorPrefix: string = 'bss.api.error';
  user: User;
  email: string;
  userRoleDetails: UserRoleDetails;
  constructor(injector: Injector, public rest: AdminService,
    public progressService: ProgressService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const sessionUserRole = sessionStorage.getItem("selectedUserRole");
    this.userRoleDetails = JSON.parse(sessionUserRole);
    this.user = this.userRoleDetails.user;
  }

  onCancel(): void {
    this.router.navigate(['secure/paddmin/resetpassword']);
  }

  // OnSubmit()
  onLost(): void {
    this.email = this.user.email;
    // console.log("click onLost")
    this.progressService.open();
    this.restSub = this.rest.setEmailAccess(this.email, 0).subscribe(response => {
      if (response.result > 0) {
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.appSuccessMessage = "bss.admin.manageUserEmailAccess.successMessage.1";

      }
    },
      (error) => {
        this.processError(error)
      },
      () => {
        this.progressService.close();
      }
    );
  }

  onRestore(): void {
    this.email = this.user.email;
    // console.log("click onLost")
    this.progressService.open();
    this.restSub = this.rest.setEmailAccess(this.email, 1).subscribe(response => {
      if (response.result > 0) {
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.appSuccessMessage = "bss.admin.manageUserEmailAccess.successMessage.2";

      }
    },
      (error) => {
        this.processError(error)
      },
      () => {
        this.progressService.close();
      }
    );
  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }
  

}
